module.exports = __webpack_public_path__ + "static/media/twitter.47cbfa33.svg";